import React from 'react';
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleLeft, faAngleDoubleRight, faAngleLeft, faAngleRight, faEdit, faFilter, faPlus, faTrashAlt, faSave } from '@fortawesome/free-solid-svg-icons';

class Listar extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        load: '',
        datosCargados: false,
        infoPQR: []
    }
    borrarRegistros = (id) => {
        Swal.fire({
            title: 'Está seguro de Eliminar el P.Q.R.?',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Borrar',
            denyButtonText: `Cancelar`,
        }).then((result) => {
            if (result.isConfirmed) {
                authAxios.get("pqr/borrar/" + id)
                    .then((datosRespuesta) => {
                        console.log(datosRespuesta);
                        Swal.fire('Borrado!', datosRespuesta.data.msj, 'success')
                        this.ListarPQR(1);
                    })
                    .catch(console.log);
            } else if (result.isDenied) {
                Swal.fire('Cancelado', '', 'info')
            }
        })
    };
    calcularFecha = (fecha) => {
        Swal.showLoading();
        authAxios.get("pqr/calcular_fecha/" + fecha)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.close();
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                //this.setState({ datosCargados: true, fecha_vencimiento: datosRespuesta.data, load: '' });
                Swal.close();
            })
            .catch(console.log);
    }
    ListarPQR(page) {
        Swal.showLoading();
        let bname = document.getElementById('bnombre').value;
        let btipo_busqueda = document.getElementById('btipo_busqueda').value;
        let bid_cod_dpto = window.localStorage.getItem('id_cod_dpto');
        let bid_cod_mpio = window.localStorage.getItem('id_cod_mpio');
        console.log(bid_cod_dpto, bid_cod_mpio, bname, btipo_busqueda);
        if (bname == '') {
            bname = 0;
        }
        if (btipo_busqueda == '') {
            btipo_busqueda = 0;
        }
        if (bid_cod_dpto == '') {
            bid_cod_dpto = 0;
        }
        if (bid_cod_mpio == '') {
            bid_cod_mpio = 0;
        }
        authAxios.get("pqr/index/" + btipo_busqueda + "/" + bname + "/" + bid_cod_dpto + "/" + bid_cod_mpio + "?page=" + page)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                Swal.close();
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({ datosCargados: true, load: '', infoPQR: datosRespuesta.data.resultadoAll, pagina: datosRespuesta.data.resultadoPaginate.total, ultimo: datosRespuesta.data.resultadoPaginate.last_page, actual: datosRespuesta.data.resultadoPaginate.current_page });
            })
            .catch(console.log);
    }

   
    componentDidMount() {
        this.ListarPQR(1);
    }
    render() {
        const { load, infoPQR, pagina, ultimo, actual } = this.state;
        return (
            <div className="content">
                <div className="container-fluid">
                    <br />
                    <div className="card">
                        <div className="card-header">
                            <Link className="btn btn-success btn-sm" to={"/AddPQR"}><FontAwesomeIcon icon={faPlus} />&nbsp;&nbsp;Nueva P.Q.R.</Link>
                        </div>
                        <div className="card-body">
                            <h4>Lista P.Q.R.</h4>
                            <hr />
                            <div className="row">
                                <div className="col-xl-2">
                                    <select name="btipo_busqueda" id="btipo_busqueda"
                                        className={"form-select form-select-sm"}
                                        onChange={this.cambioValor}>
                                        <option value="">-</option>
                                        <option value="contribuyente">CONTRIBUYENTE</option>
                                        <option value="municipio">MUNICIPIO</option>
                                        <option value="radicado">RADICADO</option>
                                        <option value="tipo_asunto">TIPO ASUNTO</option>
                                    </select>
                                </div>
                                <div className="col-xl-4">
                                    <input style={{ textTransform: 'uppercase' }} type="text" id="bnombre" name="bnombre" placeholder="P.Q.R." className="form-control form-control-sm" />
                                </div>
                                <div className="col-xl-3">
                                    <button id="bt" name="bt" className="btn btn-secondary btn-sm" onClick={() => this.ListarPQR(1)}><FontAwesomeIcon icon={faFilter} />&nbsp;&nbsp;Filtrar</button>
                                </div>
                            </div>
                            <br></br>
                            <div className="row">
                                <div className='col-xl-12'>
                                    <table className="table table-hover table-condensed table-sm">
                                        <thead className="thead-inverse">
                                            <tr>
                                                <th className="align-middle">ESTADO</th>
                                                <th className="align-middle">RADICADO</th>
                                                <th className="align-middle">TIPO ASUNTO</th>
                                                <th className="align-middle">CONTRIBUYENTE</th>
                                                <th className="align-middle">DEPARTAMENTO</th>
                                                <th className="align-middle">MUNICIPIO</th>
                                                <th className="align-middle">FECHA VENCIMIENTO</th>
                                                <th className="align-middle">DÍAS RESTANTES</th>
                                                <th className="align-middle">OPCIONES</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {load}
                                            {
                                                infoPQR.map((itemInfoPQR) => (
                                                    <tr key={itemInfoPQR.resultado.ID_PQR}>
                                                        {
                                                            (() => {
                                                                switch (itemInfoPQR.resultado.ESTADO_PQR) {
                                                                    case 1:
                                                                        return (<td><span style={{ fontSize: 11, textTransform: 'uppercase' }} className="badge bg-primary">RC</span></td>)
                                                                    case 2:
                                                                        return (<td><span style={{ fontSize: 11, textTransform: 'uppercase' }} className="badge bg-success">RS</span></td>)

                                                                }
                                                            })()
                                                        }
                                                        <td>{itemInfoPQR.resultado.RADICADO}</td>
                                                        <td>{itemInfoPQR.resultado.TIPO_ASUNTO}</td>
                                                        <td>{itemInfoPQR.resultado.NOMBRES} {itemInfoPQR.resultado.APELLIDOS}</td>
                                                        <td>{itemInfoPQR.resultado.DEPARTAMENTO}</td>
                                                        <td>{itemInfoPQR.resultado.MUNICIPIO}</td>
                                                        <td>{itemInfoPQR.resultado.FECHA_VENCIMIENTO}</td>
                                                        {
                                                            (() => {
                                                                switch (itemInfoPQR.resultado.ESTADO_PQR) {
                                                                    case 1:
                                                                        if (itemInfoPQR.dia_actual <= itemInfoPQR.resultado.FECHA_VENCIMIENTO) {
                                                                            if (itemInfoPQR.dias_restantes >= 15) {
                                                                                return (<td><span style={{ fontSize: 11, textTransform: 'uppercase' }} className="badge bg-success">{itemInfoPQR.dias_restantes} DÍAS</span></td>)
                                                                            } else {
                                                                                if (itemInfoPQR.dias_restantes >= 8 && itemInfoPQR.dias_restantes < 15) {
                                                                                    return (<td><span style={{ fontSize: 11, textTransform: 'uppercase' }} className="badge bg-warning">{itemInfoPQR.dias_restantes} DÍAS</span></td>)
                                                                                } else {
                                                                                    if (itemInfoPQR.dias_restantes >= 0 && itemInfoPQR.dias_restantes < 8) {
                                                                                        return (<td><span style={{ fontSize: 11, textTransform: 'uppercase' }} className="badge bg-danger">{itemInfoPQR.dias_restantes} DÍAS</span></td>)
                                                                                    } else {
                                                                                        return (<td><span style={{ fontSize: 11, textTransform: 'uppercase' }} className="badge bg-danger">VENCIDA!!</span></td>)
                                                                                    }
                                                                                }
                                                                            }
                                                                        } else {
                                                                            return (<td><span style={{ fontSize: 11, textTransform: 'uppercase' }} className="badge bg-danger">VENCIDA!!</span></td>)
                                                                        }
                                                                        break;
                                                                    case 2:
                                                                        return (<td><span style={{ fontSize: 11, textTransform: 'uppercase', backgroundColor: "#00A328" }} className="badge bg-success">-</span></td>)
                                                                        break;
                                                                }
                                                            })()
                                                        }
                                                        <td>
                                                            <div className="btn-group" role="group" aria-label="">
                                                                <Link
                                                                    className="btn btn-primary btn-sm"
                                                                    to={"/UpPQR/" + itemInfoPQR.resultado.ID_PQR}
                                                                >
                                                                    <FontAwesomeIcon icon={faEdit} />
                                                                </Link>&nbsp;&nbsp;
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-danger btn-sm"
                                                                    onClick={() =>
                                                                        this.borrarRegistros(itemInfoPQR.resultado.ID_PQR)
                                                                    }
                                                                >
                                                                    <FontAwesomeIcon icon={faTrashAlt} />
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <span style={{ fontSize: 11, textTransform: 'uppercase' }} className="badge bg-primary">RC</span>
                            <span style={{ fontSize: 11, textTransform: 'uppercase' }}> = <b>RECIBIDO</b></span>&nbsp;
                            <span style={{ fontSize: 11, textTransform: 'uppercase' }} className="badge bg-success">RS</span>
                            <span style={{ fontSize: 11, textTransform: 'uppercase' }}> = <b>RESUELTO</b></span>&nbsp;
                            <nav style={{ marginTop: 15 }} aria-label="Page navigation example">
                                <ul className="pagination">
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarPQR(1)}><FontAwesomeIcon icon={faAngleDoubleLeft} /></a></li>
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarPQR(actual - 1)}><FontAwesomeIcon icon={faAngleLeft} /></a></li>
                                    {(() => {
                                        let p = [];
                                        p.push(<li className="page-item" key={actual}><a className="page-link" href="#" onClick={() => this.BuscarPQR(actual)}>{actual}</a></li>);
                                        return p;
                                    })()}
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarPQR(actual + 1)}><FontAwesomeIcon icon={faAngleRight} /></a></li>
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarPQR(ultimo)}><FontAwesomeIcon icon={faAngleDoubleRight} /></a></li>
                                </ul>
                            </nav>
                        </div>
                        <div className="card-footer text-muted">
                            <b>Pagina</b> <span className="badge bg-primary">{actual}</span> <b>de</b> <span className="badge bg-primary">{ultimo}</span> | <b>Registros</b> <span className="badge bg-success">{pagina}</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Listar;